
import { Box } from "@mui/material";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";

const BillFooter = ({ title, date, noDateAndTime }) => {
  const today = date ? new Date(date) : new Date();
  const footer = JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION))?.stockLocationDetail?.posFooter;

  return (
  
     
   <>
   <div>
   
     <Box >
       <div page-footer
         dangerouslySetInnerHTML={{ __html: footer }} />
     </Box>   
   </div>
   {/* <div className="col-12">
        


          
            <div
              style={{
                fontSize:12,
                textAlign: "center",
              }}
            >
              <strong>
              {TitumDetails.SOLUTION_BY} | {TitumDetails.WEB} <br/>
               {TitumDetails.PHONE_NO} 
              </strong>
              
            </div></div> */}
 </>
  );
};

export default BillFooter;